import React, { useMemo } from 'react';
import cvData from '../../data/cv';
/**
 * An infinite auto-scrolling marquee of the top capabilities — a lively
 * transition band between hero and experience. Pure CSS animation.
 */
export function Marquee() {
  const words = useMemo(() => {
    const all = cvData.skills.flatMap(g => g.items);
    // De-dupe, keep order, cap for a tidy loop.
    return Array.from(new Set(all)).slice(0, 22);
  }, []);
  const row = [...words, ...words]; // duplicate for seamless loop
  return <div className="marquee-band group relative overflow-hidden border-y border-white/10 py-5" data-id="element-300" data-mp="1uz6y412uy0gg">
      <div className="marquee-track flex w-max gap-8 whitespace-nowrap group-hover:[animation-play-state:paused]" data-id="element-301" data-mp="1gaaucg7u39ln">
        {row.map((w, i) => <span key={i} className="flex items-center gap-8" data-id="element-302" data-mp="1l71a12fq836j" data-mpi={i}>
            <span className="font-display text-[22px] font-light text-stone-400" data-id="element-303" data-mp="28y6n59ua8hd5">
              {w}
            </span>
            <span className="text-[var(--accent)]" data-id="element-304" data-mp="2dpx25t45ztaw">✦</span>
          </span>)}
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--pf-bg)] to-transparent" data-id="element-305" data-mp="cl89uvdatgl2" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--pf-bg)] to-transparent" data-id="element-306" data-mp="marvg8sebojm" />
    </div>;
}